import React, { Dispatch, SetStateAction, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useSelector } from "react-redux";
import useOutsideClick from "../../hooks/useOutsideClick";
import { generateMenu } from "../../utils/MenuGenerator";
import ImageIcon from "../global/ImageIcon";
import pricingGreen from "../../assets/icons/pricingGreen.svg";
import deleteIcon from "../../assets/icons/DELETE __ DARK Red.svg";
import MenuIcon from "../../assets/icons/MenuIcon";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import { walletMenu, walletUserMenu } from "../../config/menuConfig";
import ModalButton from "../global/ModalButton";
import ActionModal from "../global/ActionModal";
import {
  useActivationUserForWalletMutation,
  useActivationWalletMutation,
} from "../../lib/redux/services/sections/Customers";
import { useActivateUserMutation } from "../../lib/redux/services/Api";
import useClipBoard from "../../hooks/useClipBoard";
import { toast } from "react-toastify";
import TextArea from "../global/TextArea";

type Props = {};

function WalletUserControll({
  row,
  tag,
  setRow,
  setEventType,
  setSidebarOpen,
  setIsModelTriggered,
}: {
  row: any;
  tag: string;
  setRow: React.Dispatch<any>;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
  setEventType: any;
  clubId: number;
  setIsModelTriggered: Dispatch<SetStateAction<boolean>>;
}) {
  const navigate = useNavigate();
  const { customers, shared }: DictionaryType = useGetDictionary();
  const selectedClub = useSelector((state: any) => state.user.selectedClub);
  const [deleteModal, setDeleteModal] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [openModel, setOpenModel] = useState<boolean>(false);
  const club_id = useSelector((state: any) => state.user.selectedClub);
  const tdRef = useRef<HTMLTableCellElement>(null);
  useOutsideClick(tdRef, () => {
    if (!openModel || !deleteModal) {
      setOpenModel(false);
      setIsModelTriggered(false);
    }
  });
  console.log(textAreaValue);
  const { copyText } = useClipBoard();
  const menu = generateMenu(
    //@ts-ignore
    row.link
      ? walletUserMenu
      : walletUserMenu.filter((item) => item.tag != "copyPaymentLink"),
    {
      copyPaymentLink: {
        cb: () => {
          copyText(row?.link || "", () => {
            toast.success("payment link copied successfully");
          });
        },
        isAsync: false,
        params: {},
      },
    },
    {
      activation: {
        component: (item, onClick, closeDropDown) => {
          return (
            <div className="hover:bg-gray-100 dark:hover:bg-primaryLight px-2 w-full flex items-start rounded-md  py-1  cursor-pointer  ">
              <ModalButton
                buttonStyle="w-full "
                buttonContent={
                  <div className=" w-full ">
                    <label className="flex flex-row gap-1 items-center w-full cursor-pointer ">
                      {row.status == "active" ? (
                        <img loading="lazy" src={deleteIcon} alt="" />
                      ) : (
                        <img
                          loading="lazy"
                          className="w-9"
                          src={pricingGreen}
                          alt=""
                        />
                      )}
                      <p
                        className={` text-sm ${
                          row.status == "active"
                            ? "text-red-500"
                            : " text-green-400"
                        }`}
                      >
                        {row.status == "active" ? "Deactivate" : "Activate"}
                      </p>
                    </label>
                  </div>
                }
                modalContent={
                  // <ActivateCourtModal courtId={courtId} active={isActive} />
                  <ActionModal
                    useApiAction={useActivationUserForWalletMutation}
                    ApiBody={{
                      club_id,
                      reason: textAreaValue,
                      wallet_id: row.id,
                      status:
                        row.status == "active" ? "deactivate" : "activate",
                    }}
                    titleClassName={
                      row.status == "active"
                        ? "text-primary dark:text-white"
                        : "text-primary dark:text-primaryGreen"
                    }
                    title={
                      row.status == "active"
                        ? "Confirm Activation"
                        : "Confirm De-Activation"
                    }
                    subtitle={
                      row.status == "active"
                        ? "are you sure you want to De-Activate user for this wallet?"
                        : "are you sure you want to Activate user for this wallet?"
                    }
                    firstButtonTitle={shared.no}
                    secondButtonTitle={shared.yes}
                  >
                    {row.status == "active" && (
                      <div className="text-start w-full">
                        <TextArea
                          textAreaProps={{
                            type: "text",
                            rows: 3,
                            onChange: (e: any) => {
                              setTextAreaValue(e.target.value);
                            },
                          }}
                          label={"Deactivation reason: "}
                          maxLength={1000}
                          isRequired={false}
                        />
                      </div>
                    )}
                  </ActionModal>
                }
                modalMaxWidth="max-w-lg "
              />
            </div>
          );
        },
      },
    }
  );
  return (
    <>
      <button
        //@ts-ignore
        //ref={tdRef}
        className="flex gap-2 items-center  p-2 rounded-md "
        onClick={() => {
          setOpenModel((prev) => !prev);
          setIsModelTriggered((prev) => !prev);
        }}
      >
        <ImageIcon Icon={MenuIcon} width={24} className="z-10 cursor-pointer" />
      </button>
      {/* @ts-ignore */}
      <div ref={tdRef}>
        {openModel && menu && (
          <DropDownBox
            dropDownConfig={menu}
            title=""
            closeDropDown={() => {}}
            className=" absolute top-10 -right-0 -left-2 min-w-[150px]   w-max dark:bg-primary"
          />
        )}
      </div>
    </>
  );
}

export default WalletUserControll;
